const parameters = window.URL.toString();
const headers = document.getElementsByClassName("section-group-button");
const sections = document.getElementsByClassName("hideable-section");

window.navigation.addEventListener("navigate", (e) => {
  const category = e.destination.url.split("#")[1];
  const [switchId, sectionIdentifier] = category.split("=");

  for (const header of headers) {
    if (header.id == `group-button/${switchId}/${sectionIdentifier}`)
      header.classList.add("active");
    else header.classList.remove("active");
  }

  for (const section of sections) {
    if (section.id == `hideable-section/${switchId}/${sectionIdentifier}`)
      section.classList.add("show");
    else section.classList.remove("show");
  }
});
